module.exports = __webpack_public_path__ + "img/chat_system.75cc541f.png";